module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/Avietchii/Nagano_Avietchii_MRI_RCP45_End.png";